import styled, { keyframes } from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 76px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;  
  background: rgba(16, 13, 11, 1);
`;

const fadeAnimation = keyframes`
  0% { opacity: 1; }
  40% { opacity: 0.3; }
  50% { opacity: 0.3; }
  90% { opacity: 1; }
  100% { opacity: 1; }
`;

export const AnimatedLogo = styled.img<{ src: string; alt: string }>`
  width: 45px;
  height: 45px;
  animation: ${fadeAnimation} 6s ease-in-out infinite;
`;


const CircleAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;


export const Circle = styled.div<{ color?: string }>`
  position: absolute;
  top: -15px;
  left: -15px;
  right: -15px;
  bottom: -15px;
  border-radius: 50%;
  background: ${props => `conic-gradient(from 0deg, transparent, ${props.color || '#FF7E55'})`};
  animation: ${CircleAnimation} 2s linear infinite;
  mask: radial-gradient(
    transparent calc(50% - 1px),
    #fff calc(50% - 1px),
    #fff calc(50% + 1px),
    transparent calc(50% + 1px)
  );
`;